import { Observable } from 'rxjs';
import { UseCase } from '@/core/base/use-case';
import { Details } from '../models/details.model';
import { DetailsRepository } from '../repositories/details.repository';

export class ToggleDetailsUseCase implements UseCase<void, Details> {
    constructor(private detailsRepository: DetailsRepository) {}

    execute(): Observable<Details> {
        return this.detailsRepository.toggleDetails();
    }
}
